import { FuseUtils } from '@fuse/utils';

export class Complaint {
    id: number;
    type: string;
    comment: string;

    /**
     * Constructor
     *
     * @param complaint
     */
    constructor(complaint) {
        {
            this.id = complaint.id || FuseUtils.generateGUID();
            this.type = complaint.type || '';
            this.comment = complaint.comment || '';
        }
    }
}
